import { useTranslation } from 'react-i18next';

export const CreativeCommonsHelper = () => {
    const {t} = useTranslation();
    const getHtml = (licenseType, author) => {
        author = typeof author === 'string' ? author.trim() : null;
        licenseType  = typeof author === 'string' ? licenseType.trim() : null;

        if(licenseType === null) return '';

        const [cc, acronyms] = licenseType.split(' ')
        const arrAcronyms = acronyms.split('-')

        return <p data-cc="http://creativecommons.org/ns#">
                {
                    author ? <>
                            {t('EstaObraDe')}{' '}
                            <span property="cc:attributionName">{author}</span>{' '}{t('EstaLicenciadaSob')}{' '}
                            </> :
                        <>{t('EstaObraEstaLicenciadaSob')}{' '}</>
                }
                <a
                    href={`http://creativecommons.org/licenses/${acronyms.toLowerCase()}/4.0/?ref=chooser-v1`}
                    target="_blank"
                    rel="license noopener noreferrer"
                    style={{ display: 'inline-block' }}
                >
                    CC {acronyms} 4.0
                    <img
                        alt='imagem cc'
                        style={{ height: '22px', marginLeft: '3px', verticalAlign: 'text-bottom' }}
                        src="https://mirrors.creativecommons.org/presskit/icons/cc.svg?ref=chooser-v1"
                    />
                    {
                        arrAcronyms.map((x, i) => (
                            <img
                                alt={`imagem ${x.toLowerCase()}`}
                                key={i}
                                style={{ height: '22px', marginLeft: '3px', verticalAlign: 'text-bottom' }}
                                src={`https://mirrors.creativecommons.org/presskit/icons/${x.toLowerCase()}.svg?ref=chooser-v1`}
                            />
                        ))
                    }
                </a>
            </p>
    }

    return {
        getHtml
    }
}
